<div *ngIf="productTypeIdFilter">

    <mat-accordion *ngIf="createdProductSpecificationNodes">
        <mat-expansion-panel *ngFor="let node of createdProductSpecificationNodes">
            <mat-expansion-panel-header>
                <mat-panel-title>{{ node.productSpecification.name }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="15px">
    
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input type="text" matInput [(ngModel)]="node.productSpecification.name" [disabled]="!node.addMode && !node.updateMode" required>
                </mat-form-field>
    
                <mat-form-field>
                    <mat-label>Order</mat-label>
                    <input type="number" matInput [(ngModel)]="node.productSpecification.order" [disabled]="!node.addMode && !node.updateMode" required>
                </mat-form-field>
    
                <mat-checkbox [(ngModel)]="node.productSpecification.selectable" [disabled]="!node.addMode && !node.updateMode">Selectable</mat-checkbox>
    
                <mat-checkbox [(ngModel)]="node.productSpecification.suppressOutputToProductReplacementTag" [disabled]="!node.addMode && !node.updateMode">Suppress Output To Product Replacement Tag</mat-checkbox>
    
                <div *ngIf="!node.addMode && !node.updateMode" class="p-t-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                    <button type="button" mat-stroked-button (click)="node.enableUpdateMode()">
                        <mat-icon>edit</mat-icon> Edit '{{ node.productSpecification.name }}' Specification
                    </button>
                </div>
                            
                <div *ngIf="node.updateMode" class="p-t-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                    <button type="button" mat-stroked-button (click)="node.saveUpdate()">
                        <mat-icon>save</mat-icon> Save
                    </button>
                    <button type="button" mat-stroked-button (click)="node.cancelUpdateMode()">
                        <mat-icon>cancel</mat-icon> Cancel
                    </button>
                </div>
    
                <div class="specifications-children p-l-20" >
                    <h4 class="p-l-20">Child Specifications</h4>
                    <product-specification-edit
                    [productSpecifications]="productSpecifications"
                    [productTypeIdFilter]="productTypeIdFilter"
                    [parentProductSpecificationNode]="node"
                    (onSaveUpdate)="onSaveUpdate.emit($event)"
                    (onSaveAdd)="onSaveAdd.emit($event)"
                    ></product-specification-edit>
                </div>
            </div>
      
            <div *ngIf="node.addMode" class="p-t-10" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <button type="button" mat-stroked-button (click)="saveAdd(node)">
                    <mat-icon>save</mat-icon> Save
                </button>
                <button type="button" mat-stroked-button (click)="cancelAddMode(node)">
                    <mat-icon>cancel</mat-icon> Cancel
                </button>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <button type="button" class="m-t-20" mat-stroked-button (click)="addNewNode()">
        <mat-icon>add</mat-icon> Add New Product Specification
    </button>
</div>

